<template>
    <div data-app class="md-layout uk-width-1-1" :class="role">
        <div class="uk-width-1-1">
            <md-card class="uk-margin-remove uk-width-1-1">
                <div class="uk-width-1-1 uk-padding uk-padding-remove-bottom" style="overflow: unset">
                    <div class="uk-grid uk-child-width-auto uk-flex-middle uk-width-1-1" data-uk-grid>
                        <div>
                            <h4 class="title">
                              {{local_page_keys.title_page_timetable}}
                            </h4>
                        </div>
                        <div class="uk-width-expand">
                            <div v-if="isAdmin()" class="users_list uk-width-large">
                                <v-select
                                        :options="users_list"
                                        label="text"
                                        :reduce="user => user.value"
                                        @input="changeUser"
                                        :clearable="false"
                                        class="tm-v-select">
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <md-card-content>
                    <md-table v-if="!loading && empty_schedule === ''" v-model="schedules" table-header-color="black" class="schedule schedule-table font">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell class="first-col_" :md-label="local_page_keys.label_kiev_time">
                                {{ item[0] }}<span v-if="isNight(item[0])">🌙</span>
                            </md-table-cell>
                            <!--<md-table-cell md-label="">-->
                                <!--<span v-if="isNight(item[0])"></span>-->
                            <!--</md-table-cell>-->
                            <md-table-cell v-for="day in  Object.entries(item[1])"
                                           :key="day.worker"
                                           :md-label="getLabel(day[0]) + (isAdmin() ? getCountOrder(day[0]): '')"
                                           :class="getClass(day[0])"
                                           :id="'cell-'+day[0]+item[0]">
                                <div class="loader-hide" :id="'cell-loader-'+day[0]+item[0]">
                                    <v-progress-circular :width="2" :size="20" indeterminate style="color: forestgreen"/>
                                </div>
<!--                                <button type="button" class="uk-button tm-button-schedule-table md-button md-raised md-success width"
                                           @click="showDialog(day[0], item[0], 'subscribe')"
                                           v-if="!isPast(day[0], item[0]) && !isAdmin() && !isFull(day[0], item[0]) && !isMember(day[1])">
                                  {{ local_page_keys.button_sign_up }}
                                </button>-->
                                <button type="button" class="uk-button tm-button-schedule-table md-button md-raised md-success width"
                                           @click="showDialog(day[0], item[0], 'subscribe')"
                                           v-if="!isPast(day[0], item[0]) && isAdminView() && !isMember(day[1])">
                                  {{ local_page_keys.button_recorded_by }}
                                </button>
                                <span v-if="isAdmin() && !isAdminView()">
                                    <div>
                                        <button
                                            type="button"
                                            class="uk-button tm-button-schedule-table md-button black-text-time md-theme-default"
                                            :class="timeControl[item[0]][day[0]].color"
                                            :id="'button-'+day[0]+item[0]"
                                            v-if="timeControl[item[0]] !== undefined && timeControl[item[0]] !== undefined && timeControl[item[0]][day[0]] !== undefined"
                                            >
                                            {{ timeControl[item[0]][day[0]].all }}({{ timeControl[item[0]][day[0]].use }})
                                        </button>
                                        <md-button type="button" class="uk-button tm-button-schedule-table md-button md-secondary black-text-time" v-else>
                                            {{local_page_keys.button_no_data}}<i aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light" style="color: black !important;"></i>
                                        </md-button>
                                        <div class="uk-dropdown" data-uk-dropdown="mode: click" style="padding: 0;">
                                            <div :id="day[0]+item[0]" class="retoucher-block">
                                                <ul class="retoucher-info" :class="getBackground(timeControl[item[0]][day[0]])">
                                                    <li class="retoucher-item" v-for="worker in getRetoucherTime(day[1], day[0], item[0])" :key="worker.id">
                                                      <template v-if="worker['name'] !== '' && worker['email'] !==''">
                                                        <span :id="worker['email']">
                                                            {{ '[' + worker["photos_per_hour"] + '] ' + worker['name'] }}
                                                        </span>
                                                        <span v-if="worker['role'] === 'junior-retoucher'">(test 0)</span>
<!--                                                        <span v-else>({{ worker['points'] }})</span>-->
                                                        <span v-if="worker['time']" class="itemTime">{{ worker['time'] }}</span>
                                                        <span v-else-if="!isPast(day[0], item[0]) && mustCancelReplace(worker)" class="itemTime pointer" @click="showDialog(day[0], item[0], 'cancell of replacement by admin', worker['email'], worker['name'])">
                                                            🔄
                                                        </span>
                                                        <span v-else-if="!isPast(day[0], item[0]) && !mustCancelReplace(worker)" class="itemTime pointer" @click="showDialog(day[0], item[0], 'unsubscribe', worker['email'], worker['name'])">
                                                            <md-icon>arrow_left</md-icon>
                                                        </span>
                                                        <span v-else class="itemTime"></span>
                                                      </template>
                                                    </li>
                                                </ul>
                                                <div v-if="!isPast(day[0], item[0])" class="choose-select-for-schedule" :class="getBackground(timeControl[item[0]][day[0]])">
                                                    <v-col class="d-flex" cols="8" sm="16">
                                                        <select name="users_choise_list" :id="'select' + day[0]+item[0]"
                                                                @change="selectUser"
                                                                @input="selectObjId = (day[0]+item[0])">
                                                            <option
                                                                value="">{{
                                                                local_page_keys.label_select_an_employee
                                                              }}</option>
                                                            <option v-for="user in getUsersList(item[0], day[0])"
                                                                    :key="user.item" :name="user.name"
                                                                    :value="user.value">
                                                              [{{ user.photos_per_hour }}]
                                                              {{ user.text }}
                                                            </option>
                                                        </select>
                                                    </v-col>
                                                    <button @click="showDialog(day[0], item[0], 'subscribe', selectObj)" class="uk-button uk-button-small tm-button-schedule-table md-button button-for-chooseUser md-success" v-if="selectObj !== '' && selectObjId === (day[0]+item[0])" style="width: auto !important;">
                                                        {{local_page_keys.button_recorded_by}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                                <div class="uk-text-center" v-else-if="!isAdmin() || isAdminView()">
                                    <div class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle uk-flex-center uk-text-center" data-uk-grid>
                                        <div hidden v-if="isPast(day[0], item[0]) && isMember(day[1])">
                                            ✅
                                        </div>
                                        <div hidden>
                                            ( {{ getTime(day[1]) }} )
                                        </div>
                                    </div>
                                </div>
                                <div class="uk-text-center" v-if="!isAdmin() && !isPast(day[0], item[0]) && isMember(day[1]) && mayToWrite(day[0]) ">
                                    <div>
                                        <span v-if="mayToReplace(day[1])" class="pointer">
                                            {{local_page_keys.label_recorded_by}}
                                        </span><!-- @click="showDialog(day[0], item[0], 'unsubscribe')"-->
                                        <span v-else-if="!mayToReplace(day[1]) && !mustCancelReplace(day[1])"  class="pointer">
                                            {{local_page_keys.label_recorded_by}}
                                        </span><!--@click="showDialog(day[0], item[0], 'replacement')"-->

                                        <span v-else-if="mustCancelReplace(day[1])">
                                            {{local_page_keys.label_recorded_by}}
                                        </span>
                                        <span v-if="mustCancelReplace(day[1])" class="pointer">
                                            🔄
                                        </span><!--@click="showDialog(day[0], item[0], 'cancell of replacement')"-->
                                    </div>
                                </div>
                                <div class="uk-text-center" v-else-if="isAdminView() && !isPast(day[0], item[0]) && isMember(day[1]) && !mustCancelReplace(day[1]) ">
                                    <div>
                                        <span v-if="mayToReplace(day[1])" @click="showDialog(day[0], item[0], 'unsubscribe')" class="pointer">
                                            {{local_page_keys.label_recorded_by}}
                                        </span>
                                    </div>
                                </div>
                                <div class="uk-text-center" v-else-if="!isAdmin() && !isPast(day[0], item[0]) && !mayToWrite(day[0]) && isMember(day[1]) ">
                                    <div>
                                        <span v-if="!mustCancelReplace(day[1])" class="pointer">
                                            {{local_page_keys.label_recorded_by}}
                                        </span><!--@click="showDialog(day[0], item[0], 'replacement')" -->
                                        <span v-else-if="mustCancelReplace(day[1])">
                                            {{local_page_keys.label_recorded_by}}
                                        </span>
                                        <span v-if="mustCancelReplace(day[1])" class="pointer">
                                            🔄
                                        </span><!-- @click="showDialog(day[0], item[0], 'cancell of replacement')"-->
                                    </div>
                                </div>
                                <div class="uk-text-center" v-else-if="isAdminView() && !isPast(day[0], item[0]) && mustCancelReplace(day[1]) && isMember(day[1]) ">
                                    <div>
                                        <span>
                                            {{local_page_keys.label_recorded_by}}
                                        </span>
                                        <span v-if="mustCancelReplace(day[1])" @click="showDialog(day[0], item[0], 'cancell of replacement by admin')" class="pointer">
                                            🔄
                                        </span>
                                    </div>
                                </div>
                                <div class="uk-text-center" v-else>
                                    <div v-if="isPast(day[0], item[0]) && isMember(day[1])">
                                        <div v-if="!isAdmin() || isAdminView()">
                                            <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                                                <div class="batteryOuter" :class="getClassBattery(getTime(day[1]))" :data-uk-tooltip="getDiscBattery(getTime(day[1]))">
                                                    <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid :data-battery="getTime(day[1])">
                                                        <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 14px;" v-if="getTime(day[1]) === 0">
                                                            {{local_page_keys.scheduletable_empty}}
                                                        </div>
                                                        <div v-if="getTime(day[1]) > 0">
                                                            <div class="batteryLevel"></div>
                                                        </div>
                                                        <div v-if="getTime(day[1]) > 15">
                                                            <div class="batteryLevel"></div>
                                                        </div>
                                                        <div v-if="getTime(day[1]) > 29">
                                                            <div class="batteryLevel"></div>
                                                        </div>
                                                        <div v-if="getTime(day[1]) > 45">
                                                            <div class="batteryLevel"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="batteryBump"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                    <div v-if="loading">
                        <v-progress-circular
                                :width="2"
                                indeterminate
                                style="color: forestgreen"></v-progress-circular>
                    </div>
                    <div v-else-if="!loading && empty_schedule !== ''">
                        <h2>{{ empty_schedule}}</h2>
                    </div>
                </md-card-content>
                <md-card-content>
                    <div class="pagination">
                        <pagination v-if="isAdmin()" class="text-center" :total="53" :page-count="53" :value="page" :type="currentPage(page)" @input="changePage($event)"></pagination>
                    </div>
                    <div v-if="isAdmin() && week !== page" class="uk-margin-top uk-text-center">
                        <md-button class="md-success md-small" @click="backToCurrWeek"><span class="small"><i class="fas fa-undo"></i>{{local_page_keys.label_return}}</span></md-button>
                    </div>
                </md-card-content>
            </md-card>
          <md-card v-if="role === 'admin' || role === 'mini-admin'">
            <md-card-header>
              <h3>{{ local_page_keys.title_holidays_calendar}}</h3>
            </md-card-header>
            <md-card-content>
              <AdminCalendarComponent :local_page_keys="local_page_keys"></AdminCalendarComponent>
            </md-card-content>
          </md-card>
        </div>
    </div>
</template>

<script>

import Pagination from "@/components/Pagination";
import AdminCalendarComponent from "../../../components/AdminCalendarComponent.vue";

export default {
  components: {Pagination, AdminCalendarComponent},
  data() {
    return {
      selectObj: '',
      selectObjId: '',
      page: null,
      week: null,
      schedules: [],
      role: '',
      view: 'retoucher',
      retoucher: "",
      users_list: [],
      users_to_choose: [],
      loading: true,
      timeControl: [],
      hours: null,
      empty_schedule: '',
      local_page_keys: {},
      countOrders: null
    };

  },
  methods: {
    async fetchSchedules() {
      if (!this.loading) {
        this.loading = true;
      }
      try {
        await this.$store.dispatch("schedule/schedule");
        let schedule = await this.$store.getters['schedule/schedule'];
        if (schedule.empty_schedule) {
          this.empty_schedule = schedule.empty_schedule;
          this.loading = false;
        } else {
          this.schedules = Object.entries(schedule.schedule);
          this.users_to_choose = schedule.users_to_choose;
          this.week = Number(schedule.week);
          this.page = this.week;
          this.timeControl = schedule.timeControl;
          this.hours = schedule.hours;
          this.countOrders = schedule.total;
          this.loading = false;
          if (this.isAdmin()) {
            // await this.fetchUsersList();
            if (schedule.retouchers) {
              this.formatUsersList(schedule.retouchers);
            }
          }
        }
      } catch (e) {
        alert(e);
      }
    },
    async fetchPageSchedules(page) {
      this.loading = true;
      if (this.retoucher === '') {
        try {
          await this.$store.dispatch("schedule/schedulePage", page);
          let schedulePage = await this.$store.getters["schedule/schedulePage"];
          if (schedulePage.empty_schedule) {
            this.empty_schedule = schedulePage.empty_schedule;
            this.loading = false;
          } else {
            this.users_to_choose = schedulePage.users_to_choose;
            this.schedules = Object.entries(schedulePage.schedule);
            this.hours = schedulePage.hours;
            this.timeControl = schedulePage.timeControl;
            if (this.isAdmin()) {
              if (schedulePage.retouchers) {
                this.formatUsersList(schedulePage.retouchers);
              }
              // await this.fetchUsersList();
            }

            this.loading = false;
          }

        } catch (e) {
          alert(e);
        }
      } else {
        try {
          let retoucher = this.retoucher;
          let params = {retoucher, page}
          await this.$store.dispatch("schedule/scheduleAdminPage", params);
          let scheduleAdminPage = await this.$store.getters["schedule/scheduleAdminPage"];
           if (scheduleAdminPage.empty_schedule) {
            this.empty_schedule = scheduleAdminPage.empty_schedule;
            this.loading = false;
          } else {
            this.schedules = Object.entries(scheduleAdminPage.schedule);
            this.hours = scheduleAdminPage.hours;
            this.loading = false;
          }
        } catch (e) {
          alert(e);
        }
      }
    },
    async fetchSchedulesAdmin(user_email) {
      if (!this.loading) {
        this.loading = true;
      }
      try {
        await this.$store.dispatch("schedule/scheduleAdmin", user_email);
        let scheduleAdmin = await this.$store.getters["schedule/scheduleAdmin"];
        if (scheduleAdmin.empty_schedule) {
            this.empty_schedule = scheduleAdmin.empty_schedule;
            this.loading = false;
          } else {
            this.schedules = Object.entries(scheduleAdmin.schedule);
            this.week = Number(scheduleAdmin.week);
            this.page = this.week;
            this.hours = scheduleAdmin.hours;
            this.loading = false;
         }
      } catch (e) {
        alert(e);
      }
    },
    async fetchUsersList() {
      await this.$store.dispatch("schedule/usersList");
      let usersList = await this.$store.getters['schedule/usersList'];
      if (usersList) {
        let users_list = [];
        users_list.push({
          "text": this.local_page_keys.text_users_list_all_retouchers,
          "value": "все ретушеры",
          "class": "all-retouchers"
        })
        for (let i = 0; i < usersList.length; i += 1) {
          users_list.push({
            "text": '<' + usersList[i].user_email + '>' + ' -  ' + usersList[i].user_name,
            "value": usersList[i].user_email,
            "class": ""
          });

        }
        this.users_list = users_list;
      } else {
        this.errors = this.local_page_keys.alert_failed_users_list;
      }
    },
    formatUsersList(usersList) {
      let result = [];
      result.push({
        "text": this.local_page_keys.text_users_list_all_retouchers,
        "value": "все ретушеры",
        "class": "all-retouchers"
      })
      for (let i = 0; i < usersList.length; i += 1) {
        result.push({
          "text": usersList[i].text,
          "value": usersList[i].value,
          "class": ""
        });

      }
      this.users_list = result;
    },
    /**
     * @param day
     * @param date
     * @param time
     * @returns {*[]}
     */

    getRetoucherTime: function (day, date, time) {
      var workers = [];
      for (var i in day) {
        if (day[i].name !== '' && day[i].email !== '' && (day[i].role === 'retoucher' || day[i].role === 'junior-retoucher')) {
          workers.push({
            'name': day[i].name,
            'email': day[i].email,
            'must': day[i].must,
            'replace': day[i].replace,
            'photos_per_hour': day[i].photos_per_hour ? day[i].photos_per_hour : 0,
            'role': day[i].role,
            'points': day[i].points,
            'time': (this.isPast(date, time) ? day[i].time : false)
          });
        }
      }
      return workers;
    },
    /** Method for send subscribe-unsubscribe or replace-cancel replace requests to ScheduleController
     * to methods update - route api/v1/schedule/update,
     *        and replace - route api/v1/schedule/update/replace.
     *  arguments: date - type: string, format - 'YYYY-mm-dd' - date for update or replace
     *             time - type: string, format - 'hh:mm - hh:mm' - time for update or replace
     *             msg - type: string - may be: subscribe, unsubscribe, replacement, cancell of replacement, cancell of replacement by admin,
     *             email - type: string, format - email - email of user for whom make request
     * identifiable data: selectObjId - is emty string - for cancel choosen user,
     *                     selectObj - is emty string - for cancel choosen user,
     *                     schedules - object which formed in ScheduleController by method: for retoucher and admin (if current page number matches the current week) - index;
     *                                 for admin only - indexPagination (if current page number does not matches the current week)
     *                                                  or index_Request (if admin has selected user and current page number matches the current week)
     *                                                  or indexPagination_Request (if admin has selected user and current page number does not matches the current week),
     *                     hours - object which formed in ScheduleController by methods mentioned above,
     *                     timeControl - object which formed in ScheduleController by methods mentioned above,
     *
     * */
    async showDialog(date, time, msg, email, name) {
      let week = (this.page === this.week ? '' : this.page);//define is current page number matches the current week
      let retoucher = '';
      if (!email) {
        retoucher = this.retoucher;
      } else {
        retoucher = email;
      } //define has admin chose retoucher
      let view = this.view;//define in which view we are now (admin or retoucher)
      let message = '';
      let urlToUpdate = '';
      //messages of confirm and url are generated depending on the role and msg
      if (msg === 'unsubscribe' || msg === 'subscribe' || msg === 'cancell of replacement by admin') {
        if (msg === 'unsubscribe') {
          if (this.isAdmin()) {
            message = this.local_page_keys.alert_are_you_sure_you_want_to_take_this_retoucher_off_duty_on_this_date+' ' + date + ' '+this.local_page_keys.label_time+' ' + time + '?';
          } else {
            message = this.local_page_keys.alert_are_you_sure_you_want_to_unsubscribe_from_duty_on_this_date+' ' + date + ' '+this.local_page_keys.label_time+' ' + time + '?';
          }
        } else if (msg === 'subscribe') {
          if (this.isAdmin()) {
            message = this.local_page_keys.alert_are_you_want_to_sign_this_retoucher_up_for_duty_on_this_date+' ' + ' '+this.local_page_keys.label_time+' ' + time + '?';
          } else {
            message = this.local_page_keys.alert_you_want_to_sign_this_retoucher_up_for_duty_on_this_date+' ' + ' '+this.local_page_keys.label_time+' ' + time + '?';
          }
        } else if (msg === 'cancell of replacement by admin') {
          message = this.local_page_keys.alert_retoucher_has_asked_for_a_replacement_and_a_replacement_has_not_yet_been_found;
        }
        urlToUpdate = '/schedule/update';

      } else if (msg === 'replacement' || msg === 'cancell of replacement') {
        if (msg === 'replacement') {
          message = this.local_page_keys.alert_you_are_signed_up_for_this_shift_you_can_not_miss_it;
        } else if (msg === 'cancell of replacement') {
          message = this.local_page_keys.alert_no_replacement_for_this_shift_has_yet_been_found_for_you;
        }
        urlToUpdate = '/schedule/update/replace';
      }
      //sending request to ScheduleController
      if (confirm(message)) {
        this.cellLoader(date, time, true);
        this.selectObjId = '';
        this.selectObj = '';
        let updateParams = {date, time, msg, retoucher, week, view}
        let params = { urlToUpdate, updateParams};
        await this.$store.dispatch("schedule/scheduleUpdate", params);
        let updated = await this.$store.getters["schedule/scheduleUpdate"];
        if (updated) {
          if (updated.failed) {
            this.cellLoader(date,time,false);
            alert(updated.failed)
          } else {
              if (this.isAdmin() && !this.isAdminView()) {
                this.changeOneCell(date, time, msg, retoucher, name, updated.schedule);
              } else {
                this.schedules = Object.entries(updated.schedule);//to display data in the main table
                this.cellLoader(date, time, false);
              }
              this.hours = updated.hours;//for define is may to subscribe or not
              this.timeControl = updated.timeControl;//to determine the fulfillment of work-plan
            }
          }
      }
    },
    /**
     * determines whether the current page number equals the current week number
     * @param page - type: number - number of current page
     * @returns {string} - determines class of active page
     */
    currentPage(page) {
      if (page === this.week) {
        return 'success';
      } else {
        return 'primary';
      }
    },
    /**
     * method to change pages in pagination-component
     * determines wbich info will be display on schedule page
     * @param event - type: number - number of changing page
     */
    changePage(event) {
      this.page = event;
      if (this.page !== this.week) {
        this.empty_schedule = '';
        this.fetchPageSchedules(event);
      } else if (this.page === this.week && this.retoucher === '') {
        this.empty_schedule = '';
        this.fetchSchedules();
      } else if (this.page === this.week && this.retoucher !== '') {
        this.empty_schedule = '';
        this.fetchSchedulesAdmin(this.retoucher);
      }
    },
    /**
     * difines labels for columns in ScheduleTable
     * @param info - string of date in format "YYYY-mm-dd"
     * @returns {string}
     */
    getLabel(info) {
      let date = new Date(info);//make  date-format data
      let dayWeek = this.getWeekDay(date);//determines the names of the days of the week
      return (info + `\r\n` + dayWeek); //determines label of column of table
    },

    getCountOrder(info) {
      return this.countOrders && this.countOrders[info] && this.countOrders[info] > 0 ? " (" + this.countOrders[info] + ")" : "";
    },
    /**
     * remake string date and time to date-time data format
     * @param date - string
     * @param time - string
     * @returns {*} - date-time data format
     */
    getFormatDateTime(date, time) {
      let hour = 0;
      if (time) {
        hour = this.getHour(time);
        hour = Number(hour);
        if (hour === 0) {
          hour = 24;
        }
      }
      let year = Number(date.substring(0, 4));
      let month = Number(date.substring(5, 7));
      let day = Number(date.substring(8, 10));
      if (hour != 0) {
        return new Date(year, (month - 1), day, (hour - 1));
      } else {
        return new Date(year, (month - 1), day);
      }
    },
    isPast(date, time) {
      let currdateTime = this.getFormatDateTime(date, time);
      let today = new Date();
      if (((Number(currdateTime.getTime()) - Number(today.getTime())) / (60 * 60 * 1000)) < 0) {
        return true;
      } else {
        return false;
      }
    },
    isAdmin() {
      if (this.role === 'admin' || this.role === 'mini-admin') {
        return true;
      } else {
        return false;
      }
    },
    isAdminView() {
      if (this.isAdmin() && this.view === "admin") {
        return true;
      } else {
        return false;
      }
    },
    getClass: function (info) {
      let date = new Date(info)
      let today = new Date();
      let newClass = '';

      if (date.toLocaleDateString() === today.toLocaleDateString()) {
        newClass = "today ";
      }
      newClass = newClass + "font"
      return newClass;
    },

    getWeekDay(date) {
      let days = [this.local_page_keys.label_day_week_sunday+' 👑', this.local_page_keys.label_day_week_monday, this.local_page_keys.label_day_week_tuesday, this.local_page_keys.label_day_week_wednesday, this.local_page_keys.label_day_week_thursday, this.local_page_keys.label_day_week_friday,  this.local_page_keys.label_day_week_saturday+' 👑'];

      return days[date.getDay()];
    },
    getHour(time) {
      return time.slice(-6);
    },
    isMember(data) {
      if (this.role === 'admin') {
        for (let item of data) {
          if (item.email !== '') {
            return (item.time !== 0 ? true : false);
          }
        }
      } else {
        if (data[0].time !== false) {
          return true;
        } else {
          return false;
        }
      }
    },
    getTime(data) {
      for (let item of data) {
        if (item.email !== '') {
          if (typeof (item.time) !== 'boolean') {
            return item.time;
          } else {
            return 0;
          }
        }
      }
    },
    getClassBattery(data) {
        let batteryClass = '';
        if (data === 0) {
            batteryClass = 'border-red';
        } else if (data >= 1 && data <= 15) {
            batteryClass = 'color-red';
        } else if (data >= 16 && data <= 29) {
            batteryClass = 'color-yellow';
        } else if (data >= 30 && data <= 45) {
            batteryClass = 'color-low-green';
        } else if (data >= 46) {
            batteryClass = 'color-green';
        } else {
            batteryClass = '';
        }
        return batteryClass;
    },
    getDiscBattery(data) {
        let batteryDiscription = '';
        if (data === 0) {
            batteryDiscription = this.local_page_keys.scheduletable_empty_disc;
        } else if (data >= 1 && data <= 15) {
            batteryDiscription = this.local_page_keys.scheduletable_1_15_min;
        } else if (data >= 16 && data <= 29) {
            batteryDiscription = this.local_page_keys.scheduletable_16_29_min;
        } else if (data >= 30 && data <= 45) {
            batteryDiscription = this.local_page_keys.scheduletable_30_45_min;
        } else if (data >= 46) {
            batteryDiscription = this.local_page_keys.scheduletable_46_min_and_more;
        } else {
            batteryDiscription = '';
        }
        return 'title: ' + batteryDiscription + '; pos: right';
    },
    mayToWrite(data) {
      let today = new Date();
      let dayToWrite = this.getFormatDateTime(data);
      let diff = (dayToWrite.getTime() - today.getTime()) / (60 * 60 * 24 * 1000);
      if (diff > 3) {
        return true;
      } else {
        return false;
      }
    },
    mustCancelReplace(data) {
      if (!this.isAdmin() || this.isAdminView()) {
        if (Object.entries(data)[0][1].replace) {
          return true;
        } else {
          return false;
        }
      } else {
        if (data.replace) {
          return true;
        } else {
          return false;
        }
      }

    },
    mayToReplace(data) {
      if (!Object.entries(data)[0][1].must) {
        return true;
      } else {
        return false;
      }
    },
    isNight(data) {
      const night = [
        '00.00 - 01.00',
        '01.00 - 02.00',
        '02.00 - 03.00',
        '03.00 - 04.00',
        '04.00 - 05.00',
        '05.00 - 06.00',
        '06.00 - 07.00',
      ];
      return night.includes(data) ? true : false;
    },
    changeUser(selectObj) {
      this.loading = true;
      if (selectObj === 'все ретушеры') {
        this.empty_schedule = '';
        this.view = "retoucher";
        this.retoucher = "";
        this.fetchSchedules();
      } else {
        this.empty_schedule = '';
        this.view = "admin";
        this.retoucher = selectObj;
        this.fetchSchedulesAdmin(selectObj);
      }
    },
    getBackground(data) {
      if (data !== undefined && data.color) {
        if (data.color === "md-success tm-button-scheduletable-success") {
          return 'green-list';
        } else if (data.color === "md-yellow tm-button-scheduletable-yellow") {
          return 'yellow-list';
        } else if (data.color === "md-warning tm-button-scheduletable-warning") {
          return 'orange-list';
        }
      }
    },
    backToCurrWeek() {
      if (this.retoucher === '') {
        this.fetchSchedules();
      } else {
        this.fetchSchedulesAdmin(this.retoucher);
      }
    },
    async getRole() {
      await this.$store.dispatch("profile/role");
      this.role = await this.$store.getters["profile/role"];

    },
    selectUser(selectObj) {
      this.selectObj = selectObj.target.value;
    },
    getUsersList(time, date) {
      return this.users_to_choose[time][date];
    },
    changeOneCell(date, time, msg, retoucher, name, updated) {
      this.cellLoader(date,time,false);
      let elementId = date + time;
      // let usersList = this.getUsersList(time, date);
      let selectId = 'select' + elementId;
      let selectorId = "[id='" + retoucher + "']";
      let dataAttribute = document.getElementById(elementId).attributes[0].name;
      // let buttonSelect = document.getElementById('button-' + date + time);
      let itemText = "<" + retoucher + "> - " + name;
      if (msg === 'unsubscribe' || msg === 'cancell of replacement by admin') {
          let elem =  document.getElementById(elementId);
          let nodes = elem.childNodes;
          for (let item in nodes) {
            if (nodes[item].nodeName === 'UL') {
              let listItems = nodes[item].childNodes
              for(let li in listItems) {
                if (listItems[li].nodeName === 'LI') {
                  if (listItems[li].innerText.includes(name)) {
                    listItems[li].remove();
                  }
                }
              }
            }
          }
          let users_to_choose = this.users_to_choose[time][date];
          let user_to_add = {};
          user_to_add.name = name;
          user_to_add.text = itemText;
          user_to_add.value = retoucher
          users_to_choose.splice(0, 0, user_to_add);
          // this.users_to_choose = updated.users_to_choose;
      } else if(msg == 'subscribe') {
        if (document.getElementById(elementId).querySelector(selectorId) == null){
          let selectorValue = "[value='"+retoucher+"']";
          let retoucher_name = document.getElementById(selectId).querySelector(selectorValue).getAttribute('name');
          let role = '';
          let points = 0;
          for (let workers in updated[time][date]) {
            if (updated[time][date][workers]['email'] === retoucher) {
              role = updated[time][date][workers]['role'];
              points = updated[time][date][workers]['points'];
            }
          }
          var ul = document.getElementById(elementId).firstChild;

          var li = document.createElement("li");
          var span1 = document.createElement('span');
          var span2 = document.createElement('span');
          var span3 = document.createElement('span');
          if (role === 'retoucher') {
            span3.innerText = '(' + points + ')';
          } else {
            span3.innerText = '(test 0)';
          }

          li.setAttribute(dataAttribute, "")
          li.classList.add("retoucher-item");

          span1.setAttribute('id',   retoucher);
          span1.setAttribute(dataAttribute, "");
          span1.innerText = retoucher_name;
          span2.setAttribute(dataAttribute, "");
          span2.classList.add("itemTime", "pointer");
          span2.innerHTML = '<i data-v-88139ce8="" class="md-icon md-icon-font md-theme-default">arrow_left</i>';
          span2.addEventListener("click", () => {
            this.showDialog(date, time, 'unsubscribe', retoucher, retoucher_name);
          });
          li.appendChild(span1);
          li.appendChild(span3);
          li.appendChild(span2);
          ul.appendChild(li);
          var select = document.getElementById(selectId);

          let users_to_choose = this.users_to_choose[time][date];
          let removeIndex = users_to_choose.findIndex(function (user) {
            return user.value == retoucher;
          });
          users_to_choose.splice(removeIndex, 1);
          this.users_to_choose[time][date] = users_to_choose;

          select.querySelector(selectorValue).remove();
        }
      }
    },
    cellLoader(date, time, action) {
      let cell_loader = document.getElementById("cell-loader-" + date + time);
      if (action === true) {
        cell_loader.classList.add("show");
      } else {
        cell_loader.classList.remove("show");
        // cell_loader.classList.add("hide");
      }
    }
  },
  async mounted() {
    await this.getRole();
    this.local_page_keys = await this.$filtergetLocalisationPage('timetable');
    await this.fetchSchedules();
  },
}

</script>
<style>

    /*JavaScript*/
    @import '../../../assets/css/uikit/sticky.css';
    @import '../../../assets/css/uikit/dropdown.css';
    @import '../../../assets/css/uikit/button.css';
    @import '../../../assets/css/uikit/tooltip.css';
    @import '../../../assets/css/custom.css';


    .pointer {
        cursor: pointer;

    }

    .width {
        /*width: 80px;*/
        font-weight: bold;
        font-size: 9px;
    }

    /*.saturday {*/
    /*    color: #e4bb6e;*/
    /*    font-weight: bold;*/
    /*}*/

    .font .md-table-head-label {
        font-size: 11px;
    }

    /*.sunday {*/
    /*    color: #ef3939;*/
    /*    font-weight: bold;*/
    /*}*/

    /*.today {*/
    /*    !*border-left: solid 1px #4f9b4f;*!*/
    /*    !*border-right: solid 1px #4f9b4f;*!*/
    /*    background-color: rgba(79, 155, 79, 0.15);*/
    /*}*/

    .table-transparent {
        background-color: #d28686 !important;
    }

    .mt-0 {
        margin-top: 0 !important;
    }

    .schedule .md-table-head:last-child:not(:first-child) .md-table-head-label {
        width: auto;
        /*padding-right: 0;*/
    }

/*    .schedule .md-table-head:nth-child(8) .md-table-head-label {
        color: #f7c307;
    }

    .schedule .md-table-head:nth-child(7) .md-table-head-label {
        color: red;
    }*/

    .md-table .md-table-row:hover .md-table-cell:first-child,
    .md-table .md-table-row:hover .md-table-cell{
        background-color: rgba(0,0,0,.07) !important;
    }

    /*.users_list {*/
        /*margin-top: -60px;*/
        /*margin-bottom: -50px;*/
        /*margin-left: 10%;*/
    /*}*/

    .v-progress-circular {
        display: block;
        width: 100px;
        margin: 0 auto;
    }

    .retoucher-block {
        border-color: black;
    }

    .retoucher-info {
        list-style: none;
        width: auto;
        padding: 2px;
    }

    .retoucher-item {
        margin: 2px;
        padding: 2px;
        background-color: white;
        display: flex;
        justify-content: space-between;
    }
    .retoucher-item > span {
        line-height: 30px;
    }

    .green-list {
        background-color: green;
    }

    .yellow-list {
        background-color: #fce100;
    }

    .orange-list {
        background-color: orange;
    }

    .itemTime {
        min-width: 40px;
        border: 1px solid black;
        text-align: center;
    }

    .black-text-time {
        color: black !important;
    }

    .page-item {
        width: auto;
        padding-bottom: 10px;
    }

    .pagination {
        overflow: hidden;
        justify-content: center;
    }

    .choose-select-for-schedule {
        display: flex;
        justify-content: space-between;
    }

    .button-for-chooseUser {
        margin: auto !important;
    }

    .loader-hide {
        display: none;
    }

    .loader-hide.show {
        display: block;
    }

    .schedule .md-table-head,
    .schedule .md-table-head,
    .md-table-head-container,
    .md-table-head-label,
    .md-table-head-container,
    .schedule .md-table-head-container,
    .schedule .md-table-head-label,
    .schedule .md-table-head-container,
    .schedule .md-table-head:last-child:not(:first-child) .md-table-head-label {
        font-size: 11px !important;
    }

    .schedule .md-table-head,
    .schedule .md-table-cell:nth-child(2),
    .schedule .md-table-head:nth-child(2),
    .schedule .md-table-cell:first-child,
    .schedule .md-table-head:first-child {
        max-width: 110px !important;
        min-width: 110px !important;
        width: 110px !important;
    }
    .schedule .md-table-head,
    .schedule .md-table-cell:first-child {
        text-align: center;
    }

    .md-table-head-container,
    .md-table-head-label {
        white-space: normal;
    }

    .md-table-head-container,
    .schedule .md-table-head-container {
        height: auto;
    }

    .schedule .md-table-head-container,
    .schedule .md-table-head-label {
        /*white-space: normal;*/
        padding: 0;
        /*overflow: visible;*/
        height: auto;
        line-height: 1.4;
    }

    .md-table-head {
        padding: 8px;
        font-size: 12px;
        background-color: #fff;
    }
    .md-table-head,
    .schedule .md-table-head:first-child {
        position: sticky !important;
        top: 0;
        z-index: 1;
    }
    .md-table-cell {
        padding: 5px;
        font-size: 12px;
        font-size: inherit;
        height: 35px;
    }
    .admin .md-table-cell {
        height: 41px;
    }

    .md-table-cell-container .md-button:not(:first-child):not(:last-child) {
        margin-left: 0;
        margin-right: 0;
    }

    .md-table-fixed-header-container > table,
    .md-table-content.md-scrollbar > table {
        table-layout:fixed;
    }
    .md-content.md-table-content.md-scrollbar.md-theme-default {
        max-height: calc(100vh - 135px);
        overflow: inherit;
    }
    .admin .md-content.md-table-content.md-scrollbar.md-theme-default {
        max-height: calc(100vh - 190px);
    }
    .md-table table {
        border-collapse: inherit !important;
        overflow: inherit !important;
    }
    .footer {
        display: none;
    }
    /*.content {*/
    /*    height: 100vh;*/
    /*}*/

    .md-card .md-card-content {
        padding: 10px 20px;
    }

    /* Notebook MDPI */
    @media (min-width: 1140px) and (max-width: 1367px) {
        .schedule .md-table-head,
        .schedule .md-table-cell:nth-child(2),
        .schedule .md-table-head:nth-child(2),
        .schedule .md-table-cell:first-child,
        .schedule .md-table-head:first-child {
            max-width: 85px !important;
            min-width: 85px !important;
            width: 85px !important;
        }
        .schedule .md-table-head,
        .schedule .md-table-head,
        .md-table-head-container,
        .md-table-head-label,
        .md-table-head-container,
        .schedule .md-table-head-container,
        .schedule .md-table-head-label,
        .schedule .md-table-head-container,
        .schedule .md-table-head:last-child:not(:first-child) .md-table-head-label {
            font-size: 10px !important;
        }
        .md-table-head,
        .md-table-cell {
            padding: 5px;
            font-size: 10px;
        }
    }

</style>
